import(/* webpackMode: "eager" */ "/codebuild/output/src367783891/src/unimig_frontend/components/blogs/article.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src367783891/src/unimig_frontend/components/general-page/sections/CloserLook.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src367783891/src/unimig_frontend/components/homepage/SingleBanner.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src367783891/src/unimig_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src367783891/src/unimig_frontend/node_modules/next/dist/client/script.js");
